document.addEventListener("DOMContentLoaded", function () {
  const reports = document.querySelectorAll(".nsr-blocks-report");

  if (!reports.length) {
    return;
  }

  reports.forEach(initSeoReport);

  function initSeoReport(report) {
    const daysSelect = report.querySelector(".seo-report-days");
    const mainGraph = report.querySelector("#seo-report-main-graph");

    let currentDays = parseInt(report.dataset.days || 30, 10);

    /*
     * =========================================================
     * Selected Items
     * Maximum 2 datasets at the same time.
     * =========================================================
     */

    const selectedItems = [];

    /*
     * =========================================================
     * API
     * =========================================================
     */

    async function getVolatility(type, id = null, days = currentDays) {
      /*
       * No ID = Sweden / Whole Market
       */

      if (id === null || id === undefined || id === "") {
        type = "sweden";
      }

      let url = "/wp-json/nsr-blocks/v1/volatility/" + encodeURIComponent(type);

      if (id !== null && id !== undefined && id !== "") {
        url += "/" + encodeURIComponent(id);
      }

      url += "?days=" + encodeURIComponent(days);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const text = await response.text();

      let data = null;

      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("Invalid JSON from WordPress:", text);

        throw new Error(
          "Invalid JSON response from WordPress. HTTP " + response.status,
        );
      }

      if (!response.ok) {
        const message =
          data?.message ||
          data?.code ||
          "Request failed: HTTP " + response.status;

        throw new Error(message);
      }

      return data;
    }

    /*
     * =========================================================
     * Helpers
     * =========================================================
     */

    function escapeHtml(value) {
      const div = document.createElement("div");

      div.textContent = value == null ? "" : String(value);

      return div.innerHTML;
    }

    function showLoading(container) {
      if (!container) {
        return;
      }

      container.innerHTML = `
        <div class="seo-report-loading">
          Loading...
        </div>
      `;
    }

    function showError(container, message) {
      if (!container) {
        return;
      }

      container.innerHTML = `
        <div class="seo-report-error">
          ${escapeHtml(message || "Something went wrong.")}
        </div>
      `;
    }

    /*
     * =========================================================
     * Normalize Graph Data
     * =========================================================
     */

    function normalizeGraphData(response) {
      if (!response) {
        return [];
      }

      let data = [];

      if (Array.isArray(response)) {
        data = response;
      } else if (Array.isArray(response.data)) {
        data = response.data;
      } else if (Array.isArray(response.results)) {
        data = response.results;
      }

      if (!data.length) {
        return [];
      }

      return data
        .map(function (item) {
          if (!item || typeof item !== "object") {
            return null;
          }

          const label =
            item.date ?? item.day ?? item.timestamp ?? item.label ?? "";

          const rawValue =
            item.score ??
            item.value ??
            item.movement ??
            item.volatility ??
            item.presencePercentage ??
            item.serpFunctionPercentage;

          const value = Number(rawValue);

          if (!label || Number.isNaN(value)) {
            return null;
          }

          /*
           * Always keep graph value inside 0-100.
           */

          const normalizedValue = Math.max(0, Math.min(100, value));

          return {
            label: label,
            value: normalizedValue,
          };
        })
        .filter(Boolean);
    }

    /*
     * =========================================================
     * Number Formatting
     * =========================================================
     */

    function formatNumber(value) {
      const number = Number(value);

      if (Number.isNaN(number)) {
        return String(value);
      }

      return Number.isInteger(number) ? String(number) : number.toFixed(1);
    }

    /*
     * =========================================================
     * Swedish Date Formatting
     * =========================================================
     */

    function formatDate(value) {
      if (!value) {
        return "";
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return String(value);
      }

      return new Intl.DateTimeFormat("sv-SE", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(date);
    }

    /*
     * =========================================================
     * Selected Items UI
     *
     * Shows selected datasets under the description
     * of each column.
     * =========================================================
     */

    function updateSelectedItemsUI() {
      const columns = report.querySelectorAll(".seo-report-column");

      columns.forEach(function (column) {
        const list = column.querySelector(".seo-report-list");

        const selectedList = column.querySelector(".seo-report-selected-list");

        if (!list || !selectedList) {
          return;
        }

        /*
         * Clear previous content.
         */

        selectedList.innerHTML = "";

        /*
         * Find active items inside this column.
         */

        const activeItems = list.querySelectorAll(".seo-report-item.is-active");

        /*
         * Nothing selected.
         */

        if (!activeItems.length) {
          const empty = document.createElement("span");

          empty.className = "seo-report-selected-empty";

          empty.textContent = "Not Selected";

          selectedList.appendChild(empty);

          return;
        }

        /*
         * Show selected item names.
         */

        activeItems.forEach(function (item) {
          const nameElement = item.querySelector(".seo-report-item-name");

          if (!nameElement) {
            return;
          }

          const badge = document.createElement("span");

          badge.className = "seo-report-selected-badge";

          badge.textContent = nameElement.textContent.trim();

          selectedList.appendChild(badge);
        });
      });
    }

    /*
     * =========================================================
     * Main Sweden Graph
     * =========================================================
     */

    async function loadMainGraph() {
      showLoading(mainGraph);

      try {
        const data = await getVolatility("sweden", null, currentDays);

        renderGraph(mainGraph, data);
      } catch (error) {
        console.error("Sweden movement error:", error);

        showError(mainGraph, "Unable to load Sweden movement.");
      }
    }

    /*
     * =========================================================
     * Single Graph
     * =========================================================
     */

    function renderGraph(container, response) {
      if (!container) {
        return;
      }

      const data = normalizeGraphData(response);

      if (!data.length) {
        container.innerHTML = `
          <div class="seo-report-empty">
            No graph data available.
          </div>
        `;

        return;
      }

      /*
       * Wider graph for horizontal scrolling.
       */

      const width = 900;
      const height = 310;

      const padding = {
        top: 12,
        right: 18,
        bottom: 34,
        left: 42,
      };

      const graphWidth = width - padding.left - padding.right;

      const graphHeight = height - padding.top - padding.bottom;

      /*
       * ALWAYS 0 - 100
       */

      const min = 0;
      const max = 100;

      const xStep =
        data.length > 1 ? graphWidth / (data.length - 1) : graphWidth;

      function getX(index) {
        if (data.length === 1) {
          return padding.left + graphWidth / 2;
        }

        const edgeGap = 30;

        return (
          padding.left +
          edgeGap +
          (index / (data.length - 1)) * (graphWidth - edgeGap * 2)
        );
      }
      function getY(value) {
        return padding.top + ((max - value) / (max - min)) * graphHeight;
      }

      /*
       * =======================================================
       * Grid
       * =======================================================
       */

      let grid = "";

      const gridLines = 5;

      for (let i = 0; i <= gridLines; i++) {
        const y = padding.top + (graphHeight / gridLines) * i;

        const value = max - ((max - min) / gridLines) * i;

        grid += `
          <line
            x1="${padding.left}"
            y1="${y}"
            x2="${width - padding.right}"
            y2="${y}"
            class="seo-chart-grid-line"
          />

          <text
            x="${padding.left - 12}"
            y="${y + 5}"
            text-anchor="end"
            class="seo-chart-label seo-chart-y-label"
          >
            ${escapeHtml(formatNumber(value))}
          </text>
        `;
      }

      /*
       * =======================================================
       * Points
       * =======================================================
       */

      const points = data
        .map(function (item, index) {
          return getX(index) + "," + getY(item.value);
        })
        .join(" ");

      /*
       * =======================================================
       * Area
       * =======================================================
       */

      const areaPoints =
        `${getX(0)},${height - padding.bottom} ` +
        points +
        ` ${getX(data.length - 1)},${height - padding.bottom}`;

      /*
       * =======================================================
       * X Labels
       * =======================================================
       */

      let xLabels = "";

      const maxLabels = 7;

      const labelStep = Math.max(1, Math.ceil(data.length / maxLabels));

      data.forEach(function (item, index) {
        if (index % labelStep !== 0 && index !== data.length - 1) {
          return;
        }

        xLabels += `
          <text
            x="${getX(index)}"
            y="${height - 17}"
            text-anchor="middle"
            class="seo-chart-label seo-chart-x-label"
          >
            ${escapeHtml(formatDate(item.label))}
          </text>
        `;
      });

      /*
       * =======================================================
       * Points / Tooltips
       * =======================================================
       */

      let circles = "";

      data.forEach(function (item, index) {
        circles += `
          <circle
            cx="${getX(index)}"
            cy="${getY(item.value)}"
            r="3.5"
            class="seo-chart-point"
          >
            <title>
              ${escapeHtml(formatDate(item.label))}: ${escapeHtml(
          formatNumber(item.value),
        )}
            </title>
          </circle>
        `;
      });

      /*
       * =======================================================
       * SVG
       * =======================================================
       */

      container.innerHTML = `
        <div class="seo-chart-wrapper">

          <svg
            class="seo-volatility-chart"
            viewBox="0 0 ${width} ${height}"
            preserveAspectRatio="none"
            role="img"
            aria-label="Volatility graph"
          >

            ${grid}

            <polygon
              points="${areaPoints}"
              class="seo-chart-area"
            />

            <polyline
              points="${points}"
              class="seo-chart-line"
              fill="none"
            />

            ${circles}

            ${xLabels}

          </svg>

        </div>
      `;
    }

    /*
     * =========================================================
     * Multiple Dataset Graph
     * =========================================================
     */

    function renderMultiLineGraph(container, datasets) {
      if (!container || !datasets.length) {
        return;
      }

      const validDatasets = datasets.filter(function (dataset) {
        return dataset.data && dataset.data.length;
      });

      if (!validDatasets.length) {
        container.innerHTML = `
          <div class="seo-report-empty">
            No graph data available.
          </div>
        `;

        return;
      }

      /*
       * Wider graph for mobile horizontal scroll.
       */

      const width = 900;
      const height = 310;

      const padding = {
        top: 12,
        right: 18,
        bottom: 34,
        left: 42,
      };

      const graphWidth = width - padding.left - padding.right;

      const graphHeight = height - padding.top - padding.bottom;

      /*
       * ALWAYS 0 - 100
       */

      const minValue = 0;
      const maxValue = 100;

      /*
       * Dates from first dataset.
       */

      const labels = validDatasets[0].data.map(function (item) {
        return item.label;
      });

      if (!labels.length) {
        container.innerHTML = `
          <div class="seo-report-empty">
            No graph data available.
          </div>
        `;

        return;
      }

      function getX(index) {
        if (labels.length === 1) {
          return padding.left + graphWidth / 2;
        }

        const edgeGap = 30;

        return (
          padding.left +
          edgeGap +
          (index / (labels.length - 1)) * (graphWidth - edgeGap * 2)
        );
      }

      function getY(value) {
        const safeValue = Math.max(minValue, Math.min(maxValue, Number(value)));

        return (
          padding.top +
          graphHeight -
          ((safeValue - minValue) / (maxValue - minValue)) * graphHeight
        );
      }

      let svg = `
        <svg
          class="seo-volatility-chart seo-volatility-chart-multi"
          viewBox="0 0 ${width} ${height}"
          preserveAspectRatio="none"
          role="img"
          aria-label="Volatility graph"
        >
      `;

      /*
       * =======================================================
       * Y Grid
       * =======================================================
       */

      for (let value = 0; value <= 100; value += 20) {
        const y = getY(value);

        svg += `
          <line
            x1="${padding.left}"
            y1="${y}"
            x2="${width - padding.right}"
            y2="${y}"
            class="seo-chart-grid-line"
          />

          <text
            x="${padding.left - 12}"
            y="${y + 5}"
            text-anchor="end"
            class="seo-chart-label seo-chart-y-label"
          >
            ${value}
          </text>
        `;
      }

      /*
       * =======================================================
       * X Labels
       * =======================================================
       */

      const maxLabels = 7;

      const labelStep = Math.max(1, Math.ceil(labels.length / maxLabels));

      labels.forEach(function (label, index) {
        if (index % labelStep !== 0 && index !== labels.length - 1) {
          return;
        }

        svg += `
          <text
            x="${getX(index)}"
            y="${height - 17}"
            text-anchor="middle"
            class="seo-chart-label seo-chart-x-label"
          >
            ${escapeHtml(formatDate(label))}
          </text>
        `;
      });

      /*
       * =======================================================
       * Dataset Lines
       * =======================================================
       */

      validDatasets.forEach(function (dataset, datasetIndex) {
        const points = dataset.data
          .map(function (item, index) {
            return getX(index) + "," + getY(item.value);
          })
          .join(" ");

        svg += `
            <polyline
              points="${points}"
              class="seo-chart-line seo-chart-line-${datasetIndex}"
              fill="none"
            />
          `;

        /*
         * Dataset Points
         */

        dataset.data.forEach(function (item, index) {
          svg += `
                <circle
                  cx="${getX(index)}"
                  cy="${getY(item.value)}"
                  r="3.5"
                  class="seo-chart-point seo-chart-point-${datasetIndex}"
                >
                  <title>
                    ${escapeHtml(dataset.name)} —
                    ${escapeHtml(formatDate(item.label))}:
                    ${escapeHtml(formatNumber(item.value))}
                  </title>
                </circle>
              `;
        });
      });

      svg += `</svg>`;

      /*
       * =======================================================
       * Legend
       * =======================================================
       */

      let legend = `
        <div class="seo-chart-legend">
      `;

      validDatasets.forEach(function (dataset, index) {
        legend += `
            <div class="seo-chart-legend-item">

              <span
                class="seo-chart-legend-marker seo-chart-legend-marker-${index}"
              ></span>

              <span>
                ${escapeHtml(dataset.name)}
              </span>

            </div>
          `;
      });

      legend += `</div>`;

      /*
       * =======================================================
       * Final Graph
       * =======================================================
       */

      container.innerHTML = `
        <div class="seo-chart-wrapper">
          ${svg}
          ${legend}
        </div>
      `;
    }

    /*
     * =========================================================
     * Update Main Graph
     * =========================================================
     */

    async function updateMainGraph() {
      if (!mainGraph) {
        return;
      }

      const titleElement = report.querySelector(".seo-report-header h3");

      /*
       * Nothing selected
       * -> Sweden Movement
       */

      if (!selectedItems.length) {
        if (titleElement) {
          titleElement.textContent = "Sweden Movement";
        }

        await loadMainGraph();

        return;
      }

      /*
       * Update title
       */

      if (titleElement) {
        titleElement.textContent = selectedItems
          .map(function (item) {
            return item.name;
          })
          .join(" + ");
      }

      showLoading(mainGraph);

      try {
        const datasets = [];

        /*
         * Load selected datasets.
         */

        for (const selected of selectedItems) {
          const response = await getVolatility(
            selected.type,
            selected.id,
            currentDays,
          );

          const data = normalizeGraphData(response);

          datasets.push({
            name: selected.name,
            type: selected.type,
            data: data,
          });
        }

        renderMultiLineGraph(mainGraph, datasets);
      } catch (error) {
        console.error(error);

        if (titleElement) {
          titleElement.textContent = "Sweden Movement";
        }

        showError(mainGraph, error.message || "Unable to load graph data.");
      }
    }

    /*
     * =========================================================
     * Column Expand / Collapse
     * =========================================================
     *
     * Multiple columns can stay open simultaneously.
     * =========================================================
     */

    const columnHeaders = report.querySelectorAll(".seo-report-column-header");

    columnHeaders.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const column = button.closest(".seo-report-column");

        if (!column) {
          return;
        }

        const isExpanded = column.classList.toggle("is-expanded");

        button.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      });
    });

    /*
     * =========================================================
     * List Item Click
     * =========================================================
     */

    const items = report.querySelectorAll(".seo-report-item");

    items.forEach(function (item) {
      item.addEventListener("click", async function (event) {
        /*
         * Do NOT close dropdown.
         */

        event.preventDefault();
        event.stopPropagation();

        const type = item.dataset.type || "";

        let id = item.dataset.id;

        if (id === undefined || id === "" || id === "null") {
          id = null;
        }

        const nameElement = item.querySelector(".seo-report-item-name");

        const name = nameElement ? nameElement.textContent.trim() : "";

        /*
         * Is already selected?
         */

        const existingIndex = selectedItems.findIndex(function (selected) {
          return selected.type === type && String(selected.id) === String(id);
        });

        /*
         * ===================================================
         * Remove Selection
         * ===================================================
         */

        if (existingIndex !== -1) {
          selectedItems.splice(existingIndex, 1);

          item.classList.remove("is-active");

          /*
           * Update selected labels
           */

          updateSelectedItemsUI();

          /*
           * Update graph
           */

          await updateMainGraph();

          return;
        }

        /*
         * ===================================================
         * Maximum 2 Datasets
         * ===================================================
         */

        if (selectedItems.length >= 2) {
          item.classList.add("is-limit-reached");

          setTimeout(function () {
            item.classList.remove("is-limit-reached");
          }, 300);

          return;
        }

        /*
         * ===================================================
         * Add Selection
         * ===================================================
         */

        selectedItems.push({
          type: type,
          id: id,
          name: name,
        });

        item.classList.add("is-active");

        /*
         * Update selected items
         * under column description.
         */

        updateSelectedItemsUI();

        /*
         * Update graph.
         */

        await updateMainGraph();
      });
    });

    /*
     * =========================================================
     * Days Selector
     * =========================================================
     */

    if (daysSelect) {
      daysSelect.addEventListener("change", async function () {
        const newDays = parseInt(daysSelect.value, 10);

        if (!newDays || newDays <= 0) {
          return;
        }

        currentDays = newDays;

        await updateMainGraph();
      });
    }

    /*
     * =========================================================
     * Initial Selected Items UI
     * =========================================================
     */

    updateSelectedItemsUI();

    /*
     * =========================================================
     * Initial Load
     * =========================================================
     */

    loadMainGraph();
  }
});
